import JwtDecode from 'jwt-decode';
import { JWT, JwtSub } from './types';

export const ID_ACCESS_TOKEN_KEY = 'A_JWT';
export const ID_REFRESH_TOKEN_KEY = 'R_JWT';

export default class JwtService {
  getToken(tokenKey: string): string | null {
    return window.localStorage.getItem(tokenKey);
  }

  checkIfTokenExists(tokenKey: string): boolean {
    return window.localStorage.getItem(tokenKey) !== null;
  }

  saveToken(tokenKey: string, token: string): void {
    window.localStorage.setItem(tokenKey, token);
  }

  destroyToken(tokenKey: string): void {
    window.localStorage.removeItem(tokenKey);
  }

  destroyAllTokens(): void {
    window.localStorage.removeItem(ID_REFRESH_TOKEN_KEY);
    window.localStorage.removeItem(ID_ACCESS_TOKEN_KEY);
  }

  getDecodedPayload(token: string | null): JWT | undefined {
    if (!token) { return; }
    return JwtDecode(token);
  }

  // eslint-disable-next-line
  jwtSubIsObject(jwtSub: any): jwtSub is JwtSub {
    return 'user_id' in jwtSub;
  }
}
